import { JsonSchema, RowData } from "../../../../types";
import {
  ChildCollection,
  ExportContext,
  HyperlinkMetadata,
  ParentExportRow,
  ParentWorksheet,
} from "../../../../types/types.export";
import { formatCellValue, getFieldDisplayValue } from "../exportRecordsHelpers";

const PARENT_SHEET_NAME = "Records";

export const buildParentSheet = (
  parentRows: ParentExportRow[],
  schema: JsonSchema,
  childCollections: ChildCollection[],
  context: ExportContext,
): ParentWorksheet => {
  const rows: RowData[] = [];
  const hyperlinks: HyperlinkMetadata[] = [];

  parentRows.forEach(({ row: parent, identifier }, index) => {
    const row: RowData = {};

    context.exportFields.forEach((field) => {
      const property = schema.properties[field];

      if (!property) {
        return;
      }

      if (property.isGroupId || property.enum) {
        const displayValue = getFieldDisplayValue({
          value: parent[field],
          fieldName: field,
          setupName: context.schema.title,
          property,
          iamUserState: context.iamUserState,
        });
        row[property.title] = formatCellValue(displayValue);
      } else {
        row[property.title] = formatCellValue(parent[field]);
      }
    });

    childCollections.forEach((collection) => {
      const children = parent[collection.field];
      const childCount = Array.isArray(children) ? children.length : 0;

      row[collection.title] = childCount > 0 ? `View (${childCount})` : "";

      hyperlinks.push({
        parentIdentifier: identifier.key,
        parentRowIndex: index + 2,
        childField: collection.field,
        childCount,
        columnTitle: collection.title,
      });
    });

    rows.push(row);
  });

  return {
    sheetName: context.setupName ?? PARENT_SHEET_NAME,
    rows,
    hyperlinks,
  };
};
